import { render } from "./SearchResultSupport.vue?vue&type=template&id=31516159"
import script from "./SearchResultSupport.vue?vue&type=script&lang=js"
export * from "./SearchResultSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__